import axios from 'axios'
import {
  AccountInfoDto,
  FilterQuery,
  ListAccountInfoResponseDto,
  NewTechnicianRequestBodyDto,
  UpdateTechnicianRequestBodyDto,
  ToggleActiveTechnicianBodyDto,
  UploadUrlDto,
  ListEmployeeRolesResponseDto,
  CreateNewEmployeeRoleRequestBodyDto,
  UpdateEmployeeRoleRequestBodyDto,
  EmployeeRoleDto,
  LocationProximity
} from '../definition'
import { ENV } from '../initialization'
import { putToS3, removeExifDataImage } from '../utils'

const DOMAIN = ENV.BACKEND_PREFIX_URL

export const asyncGetListTechnicians = async (
  data: FilterQuery & { searchFor?: string }
): Promise<ListAccountInfoResponseDto | undefined> => {
  const url = `${DOMAIN}/api/authentication/profile/technician`
  const response = await axios.get<ListAccountInfoResponseDto>(url, {
    params: data
  })
  return response.data
}

export const asyncGetListTechnicianLocationProximity = async (param: {
  destinationAddressId?: string
  timeSlotBeginAt?: string
  timeSlotEndAt?: string
  vendorId?: string
  mainCategoryId?: string
  taskId?: string,
  assigneeId?: string
}): Promise<LocationProximity[] | undefined> => {
  const url = `${DOMAIN}/api/booking/booking/get-nearest-employees`
  const response = await axios.get<LocationProximity[]>(url, {
    params: param
  })
  return response.data
}

export const uploadAvatar = async (avatarFile: File, customerId?: string, avatarFileId?: string) => {
  const imageNotExif = await removeExifDataImage(avatarFile)
  const url = `${DOMAIN}/api/authentication/profile/get-upload-url`
  const getUrlResponse = await axios.post<UploadUrlDto>(url, {
    fileName: imageNotExif.name,
    fileId: avatarFileId,
    ownerId: customerId,
    dataType: 'avatar'
  })
  await putToS3(imageNotExif, getUrlResponse.data.preSignUrl)
  return getUrlResponse.data
}

export const asyncCreateTechnician = async (data: NewTechnicianRequestBodyDto): Promise<AccountInfoDto | undefined> => {
  const url = `${DOMAIN}/api/authentication/profile/technician`
  const rtData = await axios.post(url, data)
  return rtData.data
}

export const asyncToggleActiveTechnician = async (id: string, data: ToggleActiveTechnicianBodyDto): Promise<void> => {
  const url = `${DOMAIN}/api/authentication/profile/technician/${id}/toggle-active`
  await axios.put(url, data)
}

export const asyncGetTechnicianDetail = async (id: string): Promise<AccountInfoDto | undefined> => {
  const url = `${DOMAIN}/api/authentication/profile/technician/${id}`
  const response = await axios.get(url)
  return response.data
}

export const asyncSaveTechnician = async (id: string, data: UpdateTechnicianRequestBodyDto): Promise<void> => {
  const url = `${DOMAIN}/api/authentication/profile/technician/${id}`
  await axios.put(url, data)
}

export const asyncDeleteTechnician = async (id: string): Promise<void> => {
  const url = `${DOMAIN}/api/authentication/profile/technician/${id}`
  await axios.delete(url)
}

export const asyncGetEmployeeRoles = async (filter?: FilterQuery): Promise<ListEmployeeRolesResponseDto> => {
  const url = `${DOMAIN}/api/authentication/profile/employee-role`
  const response = await axios.get<ListEmployeeRolesResponseDto>(url, {
    params: filter
  })
  return response.data
}

export const asyncGetEmployeeRole = async (id: string): Promise<EmployeeRoleDto> => {
  const response = await axios.get<EmployeeRoleDto>(`${DOMAIN}/api/authentication/profile/employee-role/${id}`)
  return response.data
}

export const asyncCreateEmployeeRole = async (data: CreateNewEmployeeRoleRequestBodyDto): Promise<void> => {
  await axios.post(`${DOMAIN}/api/authentication/profile/employee-role`, data)
}

export const asyncUpdateEmployeeRole = async (id: string, data: UpdateEmployeeRoleRequestBodyDto): Promise<void> => {
  await axios.put(`${DOMAIN}/api/authentication/profile/employee-role/${id}`, data)
}

export const asyncDeleteEmployeeRole = async (id: string): Promise<void> => {
  await axios.delete(`${DOMAIN}/api/authentication/profile/employee-role/${id}`)
}
